// extracted by mini-css-extract-plugin
module.exports = {"submit":"ChangeComplex_submit__1J-UX","text":"ChangeComplex_text__3eZdu","complexLabel":"ChangeComplex_complexLabel__2CFVe"};